module.exports = __webpack_public_path__ + "img/INDUSTRIA_06_prew.5885cdb6.jpg";